module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "main",
    class: {
      searchshowing: _vm.searchShowing
    }
  }, [_c('div', {
    staticClass: "menu-inner"
  }, [_c('ul', {
    staticClass: "primary-links"
  }, [_c('li', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg")
    }
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "search"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.searchShowing = !_vm.searchShowing
      }
    }
  }, [_vm._v("search")]), _vm._v(" "), (!_vm.searchShowing) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.searchShowing = true
      }
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "stretch"
    }
  }, [(_vm.searchShowing) ? _c('Autocomplete', {
    attrs: {
      "searchPlaceholder": 'Search...',
      "styling": 'inheader'
    },
    on: {
      "searchBlur": function($event) {
        _vm.searchShowing = false
      },
      "select": _vm.searchSelect
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "browse"
  }, [_c('router-link', {
    attrs: {
      "to": '/browse'
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("apps")]), _vm._v(" "), _c('span', [_vm._v("Browse")])])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "secondary-links"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "account",
    on: {
      "click": function($event) {
        _vm.$emit('accountClick')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mobile"
  }, [_vm._v("person")]), _vm._v(" "), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.$emit('pullSheetClick')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mobile"
  }, [_vm._v("photo_library")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons desktop"
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('span', [_vm._v("Pullsheet")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "phonenumber"
  }, [_c('a', {
    attrs: {
      "href": "tel:3238740404"
    }
  }, [_vm._v("(323) 874-0404")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a74a717","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 188
// module chunks = 1